import React from "react";
import { useSmoothAnchors } from "../hooks/useSmoothAnchors";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
// Core Values hidden for now — to be revisited.
// import CoreValuesSection from "../components/CoreValuesSection";
import LabsPhilosophySection from "../components/LabsPhilosophySection";
import ProductsSection from "../components/ProductsSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const HomePage = () => {
  useSmoothAnchors();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <AboutSection />
      {/* <CoreValuesSection /> */}
      <LabsPhilosophySection />
      <ProductsSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;